import { createReducer, on } from '@ngrx/store';
import {StateStatus} from "../../../shared/models/state-status.models";
import {
  addBulkRolePermission,
  addBulkRolePermissionFailure,
  addBulkRolePermissionSuccess,
  addRole,
  addRoleFailure,
  addRoleSuccess,
  loadRoles,
  loadRolesFailure,
  loadRolesSuccess,
  modifyRole,
  modifyRoleFailure,
  modifyRoleSuccess,
  removeBulkRolePermission, removeBulkRolePermissionFailure, removeBulkRolePermissionSuccess,
  removeRole,
  removeRoleFailure,
  removeRoleSuccess,
  setSelectedRoleSuccess
} from "./role.action";
import {Role} from "../../../shared/models/role.model";
export interface RoleState {
  roles: Role[];
  selectedRole: Role | null;
  error: string | null;
  roleStatus: StateStatus;
  rolePermissionStatus: StateStatus;
}

export const initialState: RoleState = {
  roles: [],
  selectedRole: null,
  error: null,
  roleStatus: 'pending' as StateStatus,
  rolePermissionStatus: 'pending' as StateStatus,
};

export const roleReducer = createReducer(
  initialState,
  on(setSelectedRoleSuccess, (state, { selectedRole }): RoleState => ({
    ...state,
    selectedRole: selectedRole,
  })),
  on(loadRoles, (state) : RoleState => ({ ...state, roleStatus: 'loading' as StateStatus })),
  on(loadRolesSuccess, (state, { roles }) : RoleState => ({
    ...state,
    roles: roles,
    error: null,
    roleStatus: 'loadSuccess' as StateStatus,
  })),
  on(loadRolesFailure, (state, { error }) : RoleState => ({
    ...state,
    error: error,
    roleStatus: 'error' as StateStatus,
  })),
  on(addRole, (state, { role }) => ({
    ...state,
    roleStatus: 'adding' as StateStatus,
  })),
  on(addRoleSuccess, (state, { role }) : RoleState => ({
    ...state,
    roleStatus: 'addSuccess' as StateStatus,
    roles: [
      role,
      ...state.roles
    ],
    selectedRole: role,
  })),
  on(addRoleFailure, (state, { error }) : RoleState  => ({
    ...state,
    roles: state.roles,
    error: error,
    roleStatus: 'error' as StateStatus,
  })),

  on(addBulkRolePermission, (state, { rolePermissions }) => ({
    ...state,
    roleStatus: 'adding' as StateStatus,
  })),
  on(addBulkRolePermissionSuccess, (state, { rolePermissions }) : RoleState => ({
    ...state,
    roleStatus: 'addSuccess' as StateStatus,
    roles: state.roles.map(role => role.id == rolePermissions[0].roleId ? {...role, rolePermissions: [...role.rolePermissions.concat(rolePermissions)]} : role),
  })),
  on(addBulkRolePermissionFailure, (state, { error }) : RoleState  => ({
    ...state,
    error: error,
    roleStatus: 'error' as StateStatus,
  })),

  on(modifyRole, (state, { role }) : RoleState  => ({
    ...state,
    roleStatus: 'modifying' as StateStatus,
    roles: state.roles.map(originalRole => {
      return originalRole.id == role.id ? {
        ...originalRole,
        name: role.name,
        description: role.description,
        autoEnableCreateForNewFeatures: role.autoEnableCreateForNewFeatures,
        autoEnableReadForNewFeatures: role.autoEnableReadForNewFeatures,
        autoEnableUpdateForNewFeatures: role.autoEnableUpdateForNewFeatures,
        autoEnableDeleteForNewFeatures: role.autoEnableDeleteForNewFeatures,
        isAdmin: role.isAdmin,
      } : originalRole;
    }),
  })),
  on(modifyRoleSuccess, (state, {role}) : RoleState => ({
    ...state,
    error: null,
    roleStatus: 'saveSuccess' as StateStatus,
  })),
  on(modifyRoleFailure, (state, { error }) : RoleState => ({
    ...state,
    roles: state.roles,
    error: error,
    roleStatus: 'error' as StateStatus,
  })),

  on(removeRole, (state, { roleId }) : RoleState => ({
    ...state,
    roleStatus: 'removing' as StateStatus
  })),
  on(removeRoleSuccess, (state, { roleId }) : RoleState => ({
    ...state,
    roles: state.roles.filter((role) => role.id != roleId),
    selectedRole: state.roles.filter((role) => role.id != roleId)[0],
    error: null,
    roleStatus: 'removeSuccess' as StateStatus,
  })),
  on(removeRoleFailure, (state, { error }) : RoleState => ({
    ...state,
    error: error,
    roleStatus: 'error' as StateStatus,
  })),

  on(removeBulkRolePermission, (state) : RoleState => ({
    ...state,
    roleStatus: 'removing' as StateStatus
  })),
  on(removeBulkRolePermissionSuccess, (state, { rolePermissionIds }) : RoleState => ({
    ...state,
    roles: state.roles.map((role) => role.id == state.selectedRole?.id ? {...role, rolePermissions: role.rolePermissions.filter(rp => !rolePermissionIds.some(deletedIds => deletedIds == rp.id))} : role),
    error: null,
    roleStatus: 'removeSuccess' as StateStatus,
  })),
  on(removeBulkRolePermissionFailure, (state, { error }) : RoleState => ({
    ...state,
    error: error,
    roleStatus: 'error' as StateStatus,
  })),


);
